export const deepMerge = (target: any, source: any): any => {
    // If either is not an object, return source (overwrite)
    if (target === null || source === null || typeof target !== 'object' || typeof source !== 'object') {
        return source;
    }

    const output = Array.isArray(target) ? [...target] : { ...target };

    for (const key of Object.keys(source)) {
        const sourceValue = source[key];
        const targetValue = target[key];

        if (sourceValue !== null && typeof sourceValue === 'object' && !Array.isArray(sourceValue)) {
            output[key] = deepMerge(targetValue, sourceValue);
        } else {
            output[key] = sourceValue;
        }
    }

    return output;
};
